export const ADMIN_PERMISSION_KEYS = [
  "dashboard",
  "users",
  "deposits",
  "withdraws",
  "results",
  "markets",
  "stake_analysis",
  "settings",
  "google_auth",
  "banners",
  "promotions",
  "notifications",
  "charts",
  "agents",
  "casino",
  "expenses",
  "sub_admins",
  "resets",
];

export function getStoredAdmin() {
  try {
    return JSON.parse(localStorage.getItem("admin") || "null");
  } catch {
    return null;
  }
}

export function isAdminSessionValid(admin = getStoredAdmin()) {
  const loginAt = Number(admin?.loginAt || 0);
  const maxAgeMs = 12 * 60 * 60 * 1000;
  const hasRole = admin?.role === "admin" || admin?.role === "sub_admin";
  return Boolean(admin && hasRole && admin?.session_token && loginAt && Date.now() - loginAt < maxAgeMs);
}

export function getAdminPermissions(admin = getStoredAdmin()) {
  const saved = admin?.permissions && typeof admin.permissions === "object" ? admin.permissions : {};
  if (admin?.role === "admin") {
    return ADMIN_PERMISSION_KEYS.reduce((acc, key) => {
      acc[key] = true;
      return acc;
    }, {});
  }
  return ADMIN_PERMISSION_KEYS.reduce((acc, key) => {
    acc[key] = saved[key] !== false;
    return acc;
  }, {});
}

export function hasAdminPermission(permissionKey, admin = getStoredAdmin()) {
  const permissions = getAdminPermissions(admin);
  return Boolean(permissions[permissionKey]);
}
